import { AnimatePresence, motion, Variants } from "framer-motion";
import React, { useEffect, useState } from "react";
import Feature1 from "./features/Feature1";
import Feature2 from "./features/Feature2";

const rotatingPhrases = [
    'websites!',
    'applications!',
    'games!',
    // Add more phrases here
];

export const listItemVariants: Variants = {
    offscreen: {
        y: 300
    },
    onscreen: {
        y: 0,
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 0.8
        }
    }
};
export const featureItemVariants: Variants = {
    offscreenRight: {
        x: 1500
    },
    offscreenLeft: {
        x: -1500
    },
    onscreen: {
        x: 0,
        transition: {
            type: "spring",
            bounce: 0.2,
            duration: 1
        }
    }
};

type FocusItem = {
    title: string,
    tag: string,
    description: React.ReactNode,
}

const focusItems: FocusItem[] = [
    {
        title: "SCP Architect X",
        tag: "Roblox Game",
        description: (
            <span>
                The newest version of SCP Architect. An advanced tatical sandbox game where you manage your own SCP Foundation. Built with Roblox-TS for type safety and scalability.
            </span>
        )
    },
    {
        title: "bWare Studios Website",
        tag: "Website",
        description: (
            <span>
                Supporting bWare.studio with, responsive layouts, and modular React sections so the studio can publish updates quickly.
            </span>
        )
    },
    {
        title: "Q-SYS Installations",
        tag: "Control + Automation",
        description: (
            <span>
                Advanced Q-SYS control systems for enterprise clients, including custom control panels, automation scripts, and routing logic.
            </span>
        )
    },
];

const Jumbotron: React.FC = () => {
    const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {

            setCurrentPhraseIndex((prevIndex) => (prevIndex + 1) % rotatingPhrases.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    const [hasScrolled, setHasScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // Get the scroll position
            const scrollY = window.scrollY;
            // Set a threshold value to determine if the page has scrolled
            const threshold = 10;
            setHasScrolled(scrollY > threshold);
        };

        // Add event listener to monitor scroll position
        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (

        <div className="bg-gray dark:bg-gray-800 overflow-hidden h-[100vh] ">
            <div className="flex justify-center items-center h-full">

                <div>


                    <h2 className="text-2xl font-extrabold text-black dark:text-white sm:text-4xl block">
                        Hi, I'm Braden.
                    </h2>
                    <h2 className="text-2xl font-extrabold text-black dark:text-white sm:text-4xl block">
                        I create&nbsp;
                        <AnimatePresence>
                            <motion.span className="text-red-500 "
                                key={currentPhraseIndex}
                                initial={{ position: 'relative', opacity: 0, scale: 0.8 }}
                                animate={{ position: 'relative', opacity: 1, scale: 1 }}
                                exit={{ position: 'absolute', opacity: 0, scale: 0.8 }}
                                transition={{ duration: 0.25 }}
                                style={{
                                    position: "absolute"
                                }}


                            >
                                {rotatingPhrases[currentPhraseIndex]}
                            </motion.span>
                        </AnimatePresence>


                    </h2>
                </div>
            </div>
            <AnimatePresence>


                {!hasScrolled && (
                    <motion.div className="overflow-hidden absolute w-full bottom-0 mb-5 flex justify-center"
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.8 }}
                        transition={{ duration: 0.5 }}
                    >
                        <p className="font-bold ">Scroll Down
                            for More</p></motion.div>
                )}
            </AnimatePresence>
            {/*<img src="/images/undraw_developer_activity_re_39tg.svg"*/}
            {/*     className="absolute  top-0 right-4 h-full  w-1/2 lg:block"/>*/}
        </div>

    );
}

const FocusSection: React.FC = () => {
    return (
        <section className="px-6 py-16 bg-gradient-to-r from-slate-950 via-slate-900 to-slate-950 text-white">
            <div className="lg:max-w-5xl mx-auto">
                <p className="text-sm font-semibold uppercase text-white/60">Current focus</p>
                <h3 className="mt-3 text-3xl font-semibold">Shipping the next wave</h3>
                <p className="mt-2 text-base text-white/70">
                    These are the live projects that define the current sprint: immersive web, immersive video games, and the Q-SYS control systems that run behind the scenes.
                </p>

                <div className="mt-10 grid gap-6 md:grid-cols-3">
                    {focusItems.map((item) => (
                        <motion.div key={item.title}
                            className="rounded-3xl border border-white/10 bg-white/5 p-5 shadow-2xl shadow-black/40 backdrop-blur"
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ type: "spring", stiffness: 140 }}
                            whileHover={{ y: -6 }}>
                            <p className="font-semibold uppercase text-white/60">{item.tag}</p>
                            <h4 className="mt-3 text-xl font-semibold">{item.title}</h4>
                            <div className="mt-2 text-sm leading-relaxed text-white/80">
                                {item.description}
                            </div>
                        </motion.div>
                    ))}
                </div>

                <div className="mt-8 flex justify-end">
                    <a className="rounded-full border border-white/20 bg-white/10 px-6 py-2 text-xs font-semibold uppercase text-white transition hover:bg-white/20"
                        href="/projects">
                        See complete project log
                    </a>
                </div>
            </div>
        </section>
    );
}

const HomeScreen: React.FC = () => {

    return (
        <div className="overflow-hidden">
            <Jumbotron />


            <Feature1 />


            <motion.div

                initial="offscreenLeft"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.25 }}
            >

                <motion.div variants={featureItemVariants}>
                    <Feature2 />
                </motion.div>
            </motion.div>
            {/* <Feature3 /> */}

            {/* <Feature4 /> */}

            <FocusSection />


        </div>
    )
}
export default HomeScreen;
